import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';

interface ActionsTemplateProps {
  insuranceId: string;
  isFirst: boolean;
  isLast: boolean;
  isDisabled: boolean;
  onMoveUp: (id: string, e: React.MouseEvent) => void;
  onMoveDown: (id: string, e: React.MouseEvent) => void;
}

/**
 * Template component for move up/down action buttons
 */
export const ActionsTemplate: React.FC<ActionsTemplateProps> = ({
  insuranceId,
  isFirst,
  isLast,
  isDisabled,
  onMoveUp,
  onMoveDown,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
    <Tooltip title={isDisabled ? "Disabled (Encounter Cancelled)" : "Move Up"}>
      <span>
        <IconButton
          size="small"
          onClick={(e) => onMoveUp(insuranceId, e)}
          disabled={isFirst || isDisabled}
          sx={{
            color: (isFirst || isDisabled) ? '#94a3b8' : '#3b82f6',
            '&:hover': {
              backgroundColor: (isFirst || isDisabled) ? 'transparent' : 'rgba(59, 130, 246, 0.1)',
            },
            '&:disabled': {
              color: '#94a3b8',
            }
          }}
        >
          <KeyboardArrowUp fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
    <Tooltip title={isDisabled ? "Disabled (Encounter Cancelled)" : "Move Down"}>
      <span>
        <IconButton
          size="small"
          onClick={(e) => onMoveDown(insuranceId, e)}
          disabled={isLast || isDisabled}
          sx={{
            color: (isLast || isDisabled) ? '#94a3b8' : '#3b82f6',
            '&:hover': {
              backgroundColor: (isLast || isDisabled) ? 'transparent' : 'rgba(59, 130, 246, 0.1)',
            },
            '&:disabled': {
              color: '#94a3b8',
            }
          }}
        >
          <KeyboardArrowDown fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  </Box>
);

export default ActionsTemplate;
